// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__LQG8n","title":"style_title__+zYJx","description":"style_description__cSKZp","actionIcon":"style_actionIcon__7WN9a"};